import styled from 'styled-components';

// Libs
import {lib} from '@drivesally/sally-ui';

// Colors
const {
  colors: {red},
} = lib;

const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  font-size: 80px;
  color: ${red};
`;

export default Container;
